// Bridges the axios response interceptor (configureAxiosAuth, in ./auth.js —
// plain JS that runs outside React) to the React tree for the
// seat_limit_exceeded lockout.
//
// The account_read_only / feature_unavailable branches next to this one
// redirect per-request, but that pattern is wrong for seat_limit_exceeded:
// it fires on reads as well as writes, so essentially every page a
// locked-out member opens would 403 and re-redirect, and there's nowhere
// useful to send them anyway — they aren't the workspace owner, so billing
// would 403 them just the same. Instead the interceptor calls
// `notifySeatLocked` once, and SeatLockGate (mounted once, high in the tree)
// subscribes and renders a persistent full-screen explanation in place of
// whatever page was about to load.
let listeners = [];

export const notifySeatLocked = (payload) => {
  listeners.slice().forEach((fn) => fn(payload));
};

export const subscribeSeatLocked = (fn) => {
  listeners.push(fn);
  return () => {
    listeners = listeners.filter((l) => l !== fn);
  };
};
